var exports = {
  "nM": "CrosspostPublishNudge.module__row___aFNaRW",
  "Io": "CrosspostPublishNudge.module__pill___aFNaRW",
  "Kk": "CrosspostPublishNudge.module__icon___aFNaRW",
  "Pf": "CrosspostPublishNudge.module__label___aFNaRW",
  "_4": "CrosspostPublishNudge.module__publishButton___aFNaRW",
  "r": "CrosspostPublishNudge.module__dismissButton___aFNaRW",
  "EL": "CrosspostPublishNudge.module__hideForeverButton___aFNaRW",
  "MW": "CrosspostPublishNudge.module__dismissIcon___aFNaRW",
};

module.exports = exports;
